export type TrainingPersona = {
  key:
    | "beginner"
    | "career_changer"
    | "beauty_therapist"
    | "experienced_practitioner"
    | "medical_professional"
    | "business_owner";
  label: string;
  cardTitle: string;
  supportingText: string;
  href: string;
};

/** Shared audience destinations used by navigation, home and catalogue links. */
export const TRAINING_PERSONAS: TrainingPersona[] = [
  {
    key: "beginner",
    label: "Beginner training",
    cardTitle: "I am new to the industry",
    supportingText: "Explore starting options and understand the steps involved.",
    href: "/courses/beginner/",
  },
  {
    key: "career_changer",
    label: "Changing career",
    cardTitle: "I am changing career",
    supportingText: "Plan training around your background and commitments.",
    href: "/courses/career-change/",
  },
  {
    key: "beauty_therapist",
    label: "For beauty therapists",
    cardTitle: "I am a beauty therapist",
    supportingText:
      "Build on the qualifications and treatments you already offer.",
    href: "/courses/beauty-therapists/",
  },
  {
    key: "experienced_practitioner",
    label: "CPD to regulated qualifications",
    cardTitle: "I already have training or experience",
    supportingText:
      "Explore progression and whether prior learning can be reviewed.",
    href: "/courses/rpl/",
  },
  {
    key: "medical_professional",
    label: "For medical professionals",
    cardTitle: "I am a medical professional",
    supportingText:
      "Explore the qualification routes relevant to your professional background.",
    href: "/courses/medical-professionals/",
  },
  {
    key: "business_owner",
    label: "Train your team",
    cardTitle: "I want to train my staff",
    supportingText: "Plan suitable training for one or more team members.",
    href: "/business-training/",
  },
];

export const TRAINING_HUB_PATH = "/which-aesthetics-course-is-right-for-me/";
export const TRAINING_QUIZ_PATH = "/best-aesthetic-course-for-you/";
